import { useRecoilState, useResetRecoilState } from 'recoil';
import { localeAtom } from '../store';

export const useLocaleState = () => {
  const [locale, setLocale] = useRecoilState(localeAtom);
  const resetLocale = useResetRecoilState(localeAtom);

  return {
    locale,
    setLocale,
    resetLocale,
  };
};
